import React, { useEffect, useState } from "react";
import axios from "axios";
import $ from "jquery";

// This is the roof proposal which we may not use anymore... This is for when we just do a roof...

import "../styles/PropView.sass";

import roofLogo from "../../../assets/images/ION Home Services Logo White 2.svg";
import rainDrops from "../../../assets/images/droplet-slash.svg";
import starterShingles from "../../../assets/images/layer-group.svg";
import underLayer from "../../../assets/images/blanket.svg";
import hipAndRidge from "../../../assets/images/square-quarters.svg";
import shingles from "../../../assets/images/house.svg";
import vents from "../../../assets/images/wind.svg";
import shingleBurntSienna from "../../../assets/images/shingleBurntSienna.png";
import shingleColonialSlate from "../../../assets/images/shingleColonialSlate.png";
import shingleGeorgetownGrey from "../../../assets/images/shingleGeorgetownGrey.png";
import shingleMoireBlack from "../../../assets/images/shingleMoireBlack.png";
import shinglePewterWood from "../../../assets/images/shinglePewterWood.png";
import shingleWeatheredWood from "../../../assets/images/shingleWeatheredWood.png";

const RoofProp = (props) => {

  const apiUrl = `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`

  let proj_id

  if (window.location.search) {
    proj_id = window.location.search.slice(9)
  } else {
    proj_id = 'a002G00000q1kF7QAI'
  }

  let quote_id;
  if (props.customer) {
    quote_id = props.roofQuote.roofQuoteId
  } else {
    quote_id = props.match.params.quote_id
  }

  const [customer, setCustomer] = useState({ name: '', street: '', city: '', zip: '' })
  const [roofQuote, setRoofQuote] = useState({ roofType: '', roofQuoteAmount: '', roofQuoteId: '' })

  const getCustomer = () => {
    axios.post(apiUrl, { method: 'get_info', project_id: proj_id }).then((res) => {
      console.log(res.data)
      return [setCustomer(res.data.data)]
    })
  }

  const getRoofQuote = () => {
    axios.post(apiUrl, { method: 'get_roof_quote', quote_id: quote_id }).then((res) => {
      console.log(res.data)
      return [setRoofQuote(res.data.roofQuote)]
    })
  }


  useEffect(() => {
    if (props.customer) {
      setCustomer({
        name: props.customer.name,
        street: props.customer.street,
        city: props.customer.city,
        zip: props.customer.zip
      })
      setRoofQuote({
        roofType: props.roofQuote.roofType,
        roofQuoteAmount: props.roofQuote.roofQuoteAmount,
        roofQuoteId: props.roofQuote.roofQuoteId
      })
      if (props.roofQuote?.roofQuoteId) {
        getRoofQuote()
      }
    } else {
      if (proj_id) {
        getCustomer()
      }
      if (quote_id) {
        getRoofQuote()
      }
    }
  }, [props.customer])

  var setupMarginScaling = function (firstClass, secondClass) {
    $(window).on('resize', function () {
      var marginRight = $(firstClass).css('margin-right'),
        marginRight15 = parseInt(marginRight) + 12;

      $(secondClass).css({
        'width': marginRight15,
      });
    });
    $(window).trigger('resize');
  }

  useEffect(() => {
    setupMarginScaling('.viewRoof .container', '.viewRoof .blur-roof')
  }, [window, customer.name])

  return (
    <div>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossOrigin="anonymous"></link>
      <div className='viewRoof'>
        <div className='container'>
          <div className='row g-0'>
          </div>
          <div className="row pt-5 mt-5 d-flex align-items-center">
            <div className="col-4">
              <img className='img' src={roofLogo} ></img>
            </div>
            <div className="col-lg-7 offset-lg-1 ps-lg-3">
              <div className='blur-roof'>
                <div className='border-bottom border-1 border-white' ></div>
              </div>
              <div className="blur roof">
                <div className='row'>
                  <div className='col pt-4'>
                    <div className='row ps-4'>
                      <div>
                        <div className='col fontNew'>ROOFING ESTIMATE PREPARED FOR</div>
                      </div>
                    </div>
                    <div className='row ps-lg-4'>
                      <div>
                        <div className='col border-bottom border-1 border-white' ></div>
                      </div>
                    </div>
                    <div className='row ps-4'>
                      <div className='col fontName mt-3'>{customer.name}</div>
                    </div>
                    <div className='row ps-4'>
                      <div className='col fontBottom pt-1' >{customer.street} {customer.city}, {customer.state} {customer.zip}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container'>
        <div>
          <div className='row'>
            <div className='row'>
              <div className='saveText v9'>ROOFING ESTIMATE</div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <ul className="leaders">
                <li>
                  <span className='savingsText v9'>Roof Type</span>
                  <span className='savingsText v9 bold'>{roofQuote.roofType}</span>
                </li>
                <li>
                  <span className='savingsText v9'>Estimate Amount</span>
                  <span className='savingsText v9 bold'>${(+roofQuote.roofQuoteAmount).toLocaleString(undefined)}</span>
                </li>
                {roofQuote.loanId > 0 ? (
                  <>
                    <li>
                      <span className='savingsText v9'>Loan Payment</span>
                      <span className='savingsText v9 bold'>${Math.round(+roofQuote.roofQuoteAmount * +roofQuote.paymentFactor).toLocaleString(undefined)}</span>
                    </li>
                    <li>
                      <span className='savingsText v9'>Loan Term</span>
                      <span className='savingsText v9 bold'>{(+roofQuote.loanTerm).toLocaleString(undefined)} Years</span>
                    </li>
                    <li>
                      <span className='savingsText v9'>Interest Rate</span>
                      <span className='savingsText v9 bold'>{(+roofQuote.loanInterest).toLocaleString(undefined)}%</span>
                    </li>
                    <li>
                      <span className='savingsText v9'>Loan Product</span>
                      <span className='savingsText v9 bold'>{roofQuote.loanName}</span>
                    </li>
                  </>
                ) : null}
                <li>
                  <span className='savingsText v9'>Estimate Number</span>
                  <span className='savingsText v9 bold'>{roofQuote.roofQuoteId}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row'>
            <div className='row'>
              <div className='saveText v9'>ROOFING WORK</div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              {roofQuote.roofType === 'Architectural Shingle' && (
                <div className='savingsText v9 par'>
                  - Remove existing shingles down to deck.<br />
                  {roofQuote.sheathing === "0" ? (
                    <span className='savingsText v9 par'>
                      - Re-nail any loose wood. If bad or rotten wood is discovered, it will be replaced at a price of $80 per sheet (which will be charged in addition to the Total Cost listed).<br />
                    </span>
                  ) : (
                    <span className='savingsText v9 par'>
                      - Furnish and install new ½” cdx plywood to roof deck.<br />
                    </span>
                  )}
                  - Install ice and water shield at all gutter lines and valleys.<br />
                  - Install synthetic underlayment to roof deck.<br />
                  - Install Certainteed SwiftStart Starter Shingles along all gutter lines and rake edges.<br />
                  - Install Certainteed Landmark Lifetime Architectural Shingles per specifications using 5- 1 1⁄4” roofing nails per shingle. <br />
                  - Install Certainteed Shadow Ridge Hip and Ridge Shingles<br />
                  - Replace vents for the existing roofing ventilation.<br />
                  - Removal of one layer of roofing material is included, any removal of additional layers of roofing materials (shingles, shakes) will be charged at $30 a square (which will be charged in addition to the Total Cost).<br />
                  - Clean up all job related debris using magnet bar.<br />
                  - Install 3/4" overhang fasteners at all open soffits, if applicable. <br />
                  <br />
                  NOTE: We must penetrate the plywood for a proper shingle hold. <br />
                  Due to modern construction and nails available to us, some dimpling of the plywood at the overhangs and minor protrusion may occur.<br />
                  <br />
                  - Pricing is only for roofing sections modeled in diagram.<br />
                  - Shingle Selection:
                </div>
              )}
              {roofQuote.roofType === 'Tile' && (
                <div className='savingsText v9 par'>
                  • Remove and haul away the entire existing roof covering. Dispose of all materials in a professional manner.<br />
                  • Remove and properly dispose of all existing 1" × 2" wood battens. Tear-off and properly dispose of underlayment. Remove all excessive debris or dirt by sweeping or blowing.<br />
                  • Additional layers of underlayment that are required to be removed will be priced at $10 a square. <br />
                  {roofQuote.sheathing === "0" ? (
                    <span className='savingsText v9 par'>
                      • Re-nail any loose wood. If bad or rotten wood is discovered, it will be replaced at a price of $80 per sheet (which will be charged in addition to the Total Cost listed).<br />
                    </span>
                  ) : (
                    <span className='savingsText v9 par'>
                      • Furnish and install new ½” cdx plywood to roof deck.<br />
                    </span>
                  )}
                  • Mechanically fasten new 1'×2'  wood battens and a new 30 year underlayment.<br />
                  • Install new drip-edge, ventilated bird-stop flashing ridge riser clips. Install new flashings if needed, missing or damaged.<br />
                  • New roofing tile to be loaded on rooftop.<br />
                  • Install new Standard Weight Tile. Style and color to be decided by customer. Tiles such as ridge, ridge-end, and rakes will be installed in specific areas.<br />
                  • Mineral flashing, (roof cement) will be applied on all hip joints and ridge transitions.<br />
                  • Weather guard to be installed on all hips and ridge transitions as needed per code.<br />
                  <br />
                  - Pricing is only for roofing sections modeled in diagram.
                </div>
              )}
              {roofQuote.roofType === 'Metal: Standing Seam' && (
                <div className='savingsText v9 par'>
                  - Remove existing shingles down to deck.<br />
                  {roofQuote.sheathing === "0" ? (
                    <span className='savingsText v9 par'>
                      - Re-nail any loose wood. If bad or rotten wood is discovered, it will be replaced at a price of $80 per sheet (which will be charged in addition to the Total Cost listed).<br />
                    </span>
                  ) : (
                    <span className='savingsText v9 par'>
                      - Furnish and install new ½” cdx plywood to roof deck.<br />
                    </span>
                  )}
                  - Install 3’ of Top shield HItemp ice and water shield at all gutter lines, rake edges, and valleys.<br />
                  - Install synthetic Hitemp underlayment to roof deck.<br />
                  - Install 26 gauge standing seam metal roofing system with hidden clip system.<br />
                  - Install new pipe and chimney flashings as needed.<br />
                  - Clean up all job related debris using magnet bar.<br />
                  - Removal of one layer of roofing material is included, any removal of additional layers of roofing materials will be charged at $30 a square (which will be charged in addition to the Total Cost).<br />
                  <br />
                  - Pricing is only for roofing sections modeled in diagram.
                </div>
              )}
              {roofQuote.roofType === 'Flat: (not tar or gravel)' && (
                <div className='savingsText v9 par'>
                  - Remove existing flat roof down to deck. <br />
                  - Removal of one layer of roofing material is included, any removal of additional layers of roofing materials will be charged at $30 a square (which will be charged in addition to the Total Cost).<br />
                  {roofQuote.sheathing === "0" ? (
                    <span className='savingsText v9 par'>
                      - Re-nail any loose wood. If bad or rotten wood is discovered, it will be replaced at a price of $80 per sheet (which will be charged in addition to the Total Cost).<br />
                    </span>
                  ) : (
                    <span className='savingsText v9 par'>
                      - Furnish and install new ½” cdx plywood to roof deck.<br />
                    </span>
                  )}
                  - Install 1/2 coverboard.<br />
                  - Install TPO to entire flat roof sections. Heat weld all seams and flashings.<br />
                  - Install new pipe and chimney flashings.<br />
                  - Clean up all job related debris using magnet bar.<br />
                  <br />
                  - Pricing is only for roofing sections modeled in diagram.<br />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row'>
            <div className='row'>
              <div className='saveText v9'>WARRANTY</div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <div className='savingsText v9 par'>- 10 year labor warranty.<br />
                - 10 year penetration warranty.<br />
                - CertainTeed limited lifetime warranty.</div>
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row d-flex align-items-center'>
            <div className='col-1'>
              <div className='roofImage svg text-center'>
                <img className='img' src={rainDrops} ></img>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='row'>
                  <div className='saveText v9 reroof'>WATERPROOF UNDERLAYMENT</div>
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='savingsText v9 par reroof'>Because it's engineered to fight water penetration, Ice and Water shield acts as a waterproofing shingle underlayment. In addition, it serves as a protective barrier that stretches and seals around nails.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row d-flex align-items-center'>
            <div className='col-1'>
              <div className='roofImage svg text-center'>
                <img className='img' src={underLayer} ></img>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='row'>
                  <div className='saveText v9 reroof'>HIGH-PERFORMANCE UNDERLAYMENT</div>
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='savingsText v9 par reroof'>Our underlayment is a high-performance, synthetic underlayment. While it provides a water-resistant layer over the roof deck, it also creates a secondary barrier against leaks. Even more, it offers protection from ice dams and wind-driven events. </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row d-flex align-items-center'>
            <div className='col-1'>
              <div className='roofImage svg text-center'>
                <img className='img' src={starterShingles} ></img>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='row'>
                  <div className='saveText v9 reroof'>STARTER SHINGLES</div>
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='savingsText v9 par reroof'>Starter shingles help create a consistent overall appearance. Not to mention, they reduce costs and installation times, and provide precision sealant for the eaves.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row d-flex align-items-center'>
            <div className='col-1'>
              <div className='roofImage svg text-center'>
                <img className='img' src={shingles} ></img>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='row'>
                  <div className='saveText v9 reroof'>ROOF SHINGLES</div>
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='savingsText v9 par reroof'>CerainTeed manufactures high-quality asphalt roofing shingles. Also, they offer a wide variety of styles and colors.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row d-flex align-items-center'>
            <div className='col-1'>
              <div className='roofImage svg text-center'>
                <img className='img' src={hipAndRidge} ></img>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='row'>
                  <div className='saveText v9 reroof'>HIP & RIDGE CAPS</div>
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='savingsText v9 par reroof'>To finish the hips and ridges of the roof, we generally rely on CertainTeed's accessory shingles.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='v9Container'>
          <div className='row d-flex align-items-center'>
            <div className='col-1'>
              <div className='roofImage svg text-center'>
                <img className='img' src={vents} ></img>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='row'>
                  <div className='saveText v9 reroof'>ROOF VENTILATION</div>
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='savingsText v9 par reroof'>To help reduce energy costs, we specifically install roofing with proper attic ventilation in mind. As a result, the air intake and exhaust create a continuous flow of outside air through to the attic.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {roofQuote.roofImg !== "" && (
        // <div className="v10Container">
        <>
          <div className="row">
            <div className="saveText v11">
              Highlighted Areas Included In This Quote
            </div>
          </div>
          <div className="row  w-100 justify-content-center mb-4">
            <div className="col px-0" align="center">
              <img className="image v4" src={roofQuote.roofImg}></img>
            </div>
          </div>
        </>
        // </div>
      )}
    </div >
  )
}

export default RoofProp